import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { AutocompleteFacility, IAutocompleteFacilityProps } from './AutocompleteFacility'

type IBaseControllerProps = ControllerProps<React.ComponentType<IAutocompleteFacilityProps>>

export interface IControlledAutocompleteFacilityProps
  extends Pick<IBaseControllerProps, 'defaultValue' | 'control'> {
  motorCarrierId: string
  label?: string
  /**
   * @default 'facility'
   */
  name?: string
  AutocompleteFacilityProps?: Partial<IAutocompleteFacilityProps['AutocompleteProps']>
}

export const ControlledAutocompleteFacility = ({
  control,
  defaultValue,
  motorCarrierId,
  name = 'facility',
  AutocompleteFacilityProps = {},
}: IControlledAutocompleteFacilityProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler: IAutocompleteFacilityProps['onChange'] = newVal => {
          if (newVal) {
            onChange(newVal)
          } else {
            onChange(null)
          }
        }

        return (
          <AutocompleteFacility
            name={name}
            onChange={changeHandler}
            value={value}
            motorCarrierId={motorCarrierId}
            AutocompleteProps={AutocompleteFacilityProps}
          />
        )
      }}
    />
  )
}
